(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studios-services"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const editionStatus = root.querySelector('[data-edition-status]');
    const cover = root.querySelector('[data-book-cover]');
    const editions = root.querySelectorAll('input[data-edition]');
    const updateEdition = input => {
      if (!input || !input.checked) return;
      if (editionStatus) editionStatus.textContent = editionStatus.dataset[input.dataset.edition];
      if (cover && input.dataset.cover) cover.src = input.dataset.cover;
    };
    editions.forEach(input => input.addEventListener('change', () => updateEdition(input)));
    updateEdition(root.querySelector('input[data-edition]:checked'));
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const reveals = root.querySelectorAll('.mzf-reveal');
    if ('IntersectionObserver' in window && !reduced.matches) {
      root.classList.add('mzf-has-motion');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), {threshold: 0.08});
      reveals.forEach(el => observer.observe(el));
    }
    const motion = root.querySelector('[data-motion]');
    motion.addEventListener('click', () => {
      const paused = root.classList.toggle('is-paused');
      motion.setAttribute('aria-pressed', String(paused));
      motion.textContent = paused ? motion.dataset.playLabel : motion.dataset.pauseLabel;
    });
    root.querySelector('[data-play]').addEventListener('click', () => {
      const holder = root.querySelector('[data-film]');
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/NTMLtm5H0N4?autoplay=1&rel=0&playsinline=1';
      iframe.title = 'Neto Treviño — Reel 2026';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      holder.replaceChildren(iframe);
      iframe.focus();
    });
    const sticky = root.querySelector('[data-sticky]');
    const book = root.querySelector('#mzf-blackbook');
    const progress = root.querySelector('.mzf-progress');
    let queued = false;
    const update = () => {
      queued = false;
      if (!root.isConnected) return;
      const b = book.getBoundingClientRect();
      const visible = window.scrollY > 600 && !(b.top < window.innerHeight && b.bottom > 100);
      sticky.classList.toggle('is-visible', visible);
      sticky.inert = !visible;
      progress.style.transform = `scaleX(${Math.min(1, Math.max(0, window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight)))})`;
    };
    window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, {passive:true});
    update();
    root.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
      const target = root.querySelector(link.getAttribute('href'));
      if (target) { event.preventDefault(); target.scrollIntoView({behavior: reduced.matches || root.classList.contains('is-paused') ? 'auto' : 'smooth', block:'start'}); history.replaceState(null,'',link.getAttribute('href')); }
    }));
  };
  document.querySelectorAll('[data-studios-funnel]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-studios-funnel]')));
})();


  } catch(e) { console.error(e); }
})();
})();
